import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ConfigApiOrigin, provideConfigApiOrigin } from './config-api-origin.token';
import { ConfigService } from './config.service';
import { provideConfigInitializer } from './config.initializer';

export function provideConfig(options: ConfigApiOrigin): EnvironmentProviders {
  return makeEnvironmentProviders([provideConfigApiOrigin(options), ConfigService, provideConfigInitializer()]);
}
